import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {vanityThumbnail} from "../../../bvComponent/core/assets";
import {METADATA, VANITY_TYPES, LOOK_ROOM_TYPES, VANITY_HANDLES} from "../constants";

import VanityHandle from "../subparts/vanity/vanityHandle";
import VanityCabinet from "../subparts/vanity/vanityCabinet";
import VanityCountertop from "../subparts/vanity/vanityCountertop";
import VanityBacksplash from "../subparts/vanity/vanityBacksplash";
import Mirror from "../subparts/vanity/mirror";
import Sink from "../subparts/vanity/sink";
import VanityFaucet from "../subparts/vanity/faucet";
import Ptrap from "../subparts/vanity/pTrap";
import VanityWashstand from "../subparts/vanity/vanityWashstand";
import VanityMiddle from "../subparts/vanity/vanityMiddle";
import DrawerPull from "../subparts/vanity/drawerPull";
import WSTowelBar from "../subparts/vanity/wsTowelBar";
import VanityLegs from "../subparts/vanity/vanityLegs";
import VanityConsole from "../subparts/vanity/vanityConsole";
import {getDbFeatureProperty, getSkuWithoutDot} from "../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../appLayout";
import DoorHandle from "../subparts/vanity/doorHandle";
import DrawerHandle from "../subparts/vanity/drawerHandle";
import VanityLighting from "../subparts/vanity/vanityLighting";

export class Vanity extends Part {
  static id = 'Vanity';

  static Types = {
    Complete: 'Complete',
    Custom: 'Custom'
  };

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Vanity';
    this.translateId = "visualizer.bathroom.vanity";
    this.partThumbnail = vanityThumbnail;
    this.activeSubType_ = Vanity.Types.Custom;
    this.relatedItems = [];
    this.placeholdersNeeded = false;  // only Vanity property

    // vanity parts
    this.vanityCabinet = null;
    this.completeVanity = null;
    this.countertop = null;
    this.sink = null;
    this.faucet = null;
    this.vanityBacksplash = null;
    this.vanityHandle = null;
    this.mirror = null;
    this.vanityPTrap = null;
    this.vanityWashstand = null;
    this.vanityMiddle = null;
    this.drawerPull = null;
    this.wsTowelBar = null;
    this.vanityLegs = null;
    this.vanityLegs = null;
    this.vanityConsole = null;
    this.doorHandle = null;
    this.drawerHandle = null;
    this.vanityLighting = null;

    this.vanity_type = VANITY_TYPES.vanity_cabinet;
    this.relatedGroupNames = ["Sink", "Mirror", "Countertop", "Faucet", "VanityBacksplash", "Vanity Handle", "Vanity",
      "Ptrap", "Washstand", "Vanity Middle", "Drawer Pull", "WS Towel Bar", "Vanity Legs", "Console", "Door Handle",
      "Drawer Handle", "Vanity Lighting"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Sink":
        relatedItemName = "sink";
        RelatedItemClass = Sink;
        break;
      case "Mirror":
        relatedItemName = "mirror";
        RelatedItemClass = Mirror;
        break;
      case "Countertop":
      case "Vanitie Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = VanityCountertop;
        break;
      case "Faucet":
        relatedItemName = "faucet";
        RelatedItemClass = VanityFaucet;
        break;
      case "VanityBacksplash":
      case "BackSplash":
      case "Backsplash":
        relatedItemName = "vanityBacksplash";
        RelatedItemClass = VanityBacksplash;
        break;
      case "Vanity Handle":
        relatedItemName = "vanityHandle";
        RelatedItemClass = VanityHandle;
        break;
      case "Vanity Lighting":
        relatedItemName = "vanityLighting";
        RelatedItemClass = VanityLighting;
        break;
      case "Door Handle":
        relatedItemName = "doorHandle";
        RelatedItemClass = DoorHandle;
        break;
      case "Drawer Handle":
        relatedItemName = "drawerHandle";
        RelatedItemClass = DrawerHandle;
        break;
      case "Vanity":
      case "Vanitie": {
        relatedItemName = "vanityCabinet";
        RelatedItemClass = VanityCabinet;
        break;
      }
      case "Ptrap": {
        relatedItemName = "vanityPTrap";
        RelatedItemClass = Ptrap;
        break;
      }
      case "Washstand": {
        relatedItemName = "vanityWashstand";
        RelatedItemClass = VanityWashstand;
        break;
      }
      case "Vanity Middle": {
        relatedItemName = "vanityMiddle";
        RelatedItemClass = VanityMiddle;
        break;
      }
      case "Drawer Pull": {
        relatedItemName = "drawerPull";
        RelatedItemClass = DrawerPull;
        break;
      }
      case "WS Towel Bar": {
        relatedItemName = "wsTowelBar";
        RelatedItemClass = WSTowelBar;
        break;
      }
      case "Vanity Legs": {
        relatedItemName = "vanityLegs";
        RelatedItemClass = VanityLegs;
        break;
      }
      case "Console": {
        relatedItemName = "vanityConsole";
        RelatedItemClass = VanityConsole;
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName === "sink") {
          const faucetIndex = this.relatedItems.findIndex(relItem => relItem.partName === 'Faucet');
          faucetIndex ? this.relatedItems.splice(faucetIndex, 0, this.sink) : this.relatedItems.push(this.sink);
        } else if (relatedItemName === "completeVanity") {
          this.relatedItems.unshift(this.completeVanity); // cabinet needs to be first in the list.
        } else if (relatedItemName === "vanityCabinet") {
          this.relatedItems.unshift(this.vanityCabinet); // cabinet needs to be first in the list.
        } else {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      if (loadFeature) {
        this[relatedItemName].load(dbFeature);
      }
      return true
    }
    return false
  }

  getRelatedItems() {
    return this.relatedItems.filter(item => item.visible.includes(this.activeSubType_));
  }

  subTypes() {
    return this.vanityCabinet && this.completeVanity ? [Vanity.Types.Custom, Vanity.Types.Complete] : [];
  }

  isSubTypeWithItems() {
    return this.activeSubType_ === Vanity.Types.Complete;
  }

  activeSubType() {
    return this.activeSubType_;
  }

  subParts() {
    const relatedItems = this.getRelatedItems();
    const excluded = [];
    const vanityPart = relatedItems.find(navItem => navItem.partId === "vanity_cabinet");
    if (vanityPart && vanityPart.activeFeature
      && vanityPart.activeFeature.metaData["VanityHandle"]
      && vanityPart.activeFeature.metaData["VanityHandle"].includes("None")) {
      excluded.push("vanity_handle")
    }
    return relatedItems
      .filter(item => !excluded.includes(item.partId))
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  // subPartsWithAccentWall() {
  //   const vanityAccent = this.layout.parts.Walls.vanityAccent;
  //   return [new DesignNavigationItem(vanityAccent.partName, vanityAccent),
  //     ...this.getRelatedItems().map(_ => new DesignNavigationItem(_.partName, _))];
  // }

  handleSubTypeClick(subType) {
    this.activeSubType_ = subType;
    this.getRelatedItems().forEach((relatedItem) => {
      if (!relatedItem.activeFeature) {
        relatedItem.setDefault()
      }
    });
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  setDefault(layout) {
    this.getRelatedItems().forEach(_ => _.setDefault(layout));
  }

  counterTopSize(forFeatureGroup) {
    const useCabinetVanitySize = forFeatureGroup && VANITY_HANDLES.includes(forFeatureGroup.partId);
    const currentCountertopSize = useCabinetVanitySize
      ? this.getCounterTopSize(VANITY_TYPES.vanity_cabinet)
      : this.getCounterTopSize();
    let vanitySize = currentCountertopSize || "24"; // we have left and right mirror for "L" & "R" or single for "C"
    if ((vanitySize === "72" || (Array.isArray(vanitySize) && vanitySize[0] === ("72")))
      && forFeatureGroup && !(forFeatureGroup.partId === "vanity_backsplash"
        || forFeatureGroup.partId === "vanity_countertop"
        || forFeatureGroup.partId === "door_handle"
        || forFeatureGroup.partId === "drawer_handle"
      )) {
      return ["64"]; // use 64 for everything except counterop and backsplash // and handles
    }
    return vanitySize
  }

  getCounterTopSize(forVanityType = this.vanity_type) {
    const currentVanityTypeFeatureGroup = this.relatedItems.find(relItem => relItem.partId === forVanityType);
    if (currentVanityTypeFeatureGroup && !currentVanityTypeFeatureGroup.activeFeature) {
      this.vanityCabinet.setDefault()
    }
    return (currentVanityTypeFeatureGroup && currentVanityTypeFeatureGroup.activeFeature)
      ? currentVanityTypeFeatureGroup.activeFeature.dbFeature.metaData["VanitySize"]
      : null;
  }

  isDoubleVanity(feature = null) {
    if (this.vanity_type !== VANITY_TYPES.vanity_cabinet || !this.vanityCabinet) {
      return false
    }
    const checkFeature = feature || this.vanityCabinet.activeFeature;
    return checkFeature && checkFeature.metaData["VanityWidth"] && (checkFeature.metaData["VanityWidth"] === 64)
  }

  toggleVanityParts(disabled) {
    this.getRelatedItems().forEach(relItem => {
      if (relItem.partId === "vanity_sink" || relItem.partId === "vanity_faucet"
        || relItem.partId === "vanity_countertop" || relItem.partId === "vanity_cabinet"
        || relItem.partId === "vanity_handle" || relItem.partId === "vanity_backsplash") {
        relItem.disabled = disabled;
      }
    });
  }

  getActiveSkuFromRelatedItem(partId) {
    const relatedItem = this.relatedItems.find(relItem => relItem.partId === partId);
    return relatedItem && relatedItem.activeFeature && relatedItem.activeFeature.dbFeature.sharedFeatureName
      ? getSkuWithoutDot(relatedItem.activeFeature.dbFeature.sharedFeatureName)
      : null
  }

  getActiveMatchingMetaFromRelatedItem(partId, metaName = "MatchingFeature") {
    const relatedItem = this.relatedItems?.find(relItem => relItem.partId === partId);
    return relatedItem && relatedItem.activeFeature
      ? relatedItem.activeFeature.metaData[metaName]
      : null
  }

  setCustomVanitySinkMetaData(feature) {
    switch (feature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")]) {
      case "Pedestal Bathroom Sinks":
        return "Pedestal"
      case "Above Counter Sinks with Vessel":
      case "Countertop Bathroom Sinks":
        return "Top Mount"
      case "Undermount Bathroom Sinks":
      case "Undermount Sinks":
        return "Undermount"
      default:
        return ""
    }
  }

  setSpecificRules(isAsBathroomState = false) {
    // console.log("setSpecificRules", isAsBathroomState);
    if (getCurrentRoomType(this.layout) === LOOK_ROOM_TYPES.as || isAsBathroomState) {
      const sinkFeatureGroup = this.relatedItems.find(relItem => relItem.partId === "vanity_sink");
      this.relatedItems.forEach(relItem => {
        Object.keys(relItem.featuresList).forEach(layoutName => {
          [...relItem.featuresList[layoutName], ...relItem.featuresPartsList[layoutName]].map(feature => {
            feature.dbFeature.metaData["FeatureSku"] = [getSkuWithoutDot(feature.dbFeature.sharedFeatureName)];
            if (relItem.partId === "vanity_sink" && Array.isArray(feature.dbFeature.metaData["MatchingFeature"])) {
              feature.dbFeature.metaData["CustomSinkSubCategory"] = this.setCustomVanitySinkMetaData(feature);
              feature.metaData["CustomSinkSubCategory"] = this.setCustomVanitySinkMetaData(feature);
              let sinkTypes = [];
              feature.dbFeature.metaData["MatchingFeature"].forEach(currentSku => {
                Object.keys(VANITY_TYPES).forEach(partId => {
                  const featureGroup = this.relatedItems.find(relItem => relItem.partId === partId);
                  if (featureGroup) {
                    const feature = [...featureGroup.featuresList[layoutName], ...featureGroup.featuresPartsList[layoutName]].find(testFeature => {
                      return getSkuWithoutDot(testFeature.dbFeature.sharedFeatureName) === currentSku
                    });
                    if (feature) {
                      sinkTypes.push(feature.partId)
                    }
                  } else {
                    // console.log("no feature group found to apply sink metadata", partId);
                  }
                })
              });
              if (feature.dbFeature.metaData["MatchingFeature"] && feature.dbFeature.metaData["MatchingFeature"].includes(METADATA.NO)) {
                sinkTypes.push(VANITY_TYPES.vanity_cabinet);
                feature.dbFeature.metaData["FeatureSku"] = [METADATA.ALL];
                feature.metaData["FeatureSku"] = [METADATA.ALL];
              }
              // if (!sinkTypes.length && feature.dbFeature.metaData["MountType"] && feature.dbFeature.metaData["MountType"].includes('ST')) {
              //   sinkTypes.push(METADATA.ALL)
              // }
              feature.dbFeature.metaData["CustomVanityType"] = sinkTypes; // create custom metadata
              feature.metaData["CustomVanityType"] = sinkTypes; // create custom metadata
            }
            if (relItem.partId === "vanity_cabinet" && Array.isArray(feature.dbFeature.metaData["MatchingFeature"]) && sinkFeatureGroup) {
              let sinkTypes = [];
              feature.dbFeature.metaData["MatchingFeature"].forEach(currentSku => {
                const sinkFeature = [...sinkFeatureGroup.featuresList[layoutName], ...sinkFeatureGroup.featuresPartsList[layoutName]].find(testFeature => {
                  return getSkuWithoutDot(testFeature.dbFeature.sharedFeatureName) === currentSku
                });
                if (sinkFeature) {
                  const type = this.setCustomVanitySinkMetaData(sinkFeature);
                  if (!sinkTypes.includes(type)) {
                    sinkTypes.push(this.setCustomVanitySinkMetaData(sinkFeature))
                  }
                }
              });
              feature.dbFeature.metaData["CustomSinkSubCategory"] = sinkTypes; // create custom metadata
              feature.metaData["CustomSinkSubCategory"] = sinkTypes; // create custom metadata
            }
            // console.log("feature.metaData[\"CustomVanityType\"]", feature.metaData["CustomVanityType"]);
            // console.log("feature", feature);
            return feature
          })
        })
      })
    }
    this.needToUpdateCustomMetadata = false;
  }

  updateVanityParts() {
    if (getCurrentRoomType(this.layout) === LOOK_ROOM_TYPES.as) {
      this.relatedItems.forEach(relatedItem => {
        if (relatedItem.hideLayerCondition) {
          relatedItem.disabled = relatedItem.hideLayerCondition();
        }
      });
    }
  }

}

